import styled  from "styled-components";
import { space, layout } from "styled-system";
import propTypes from "@styled-system/prop-types";
import themeGet from "@styled-system/theme-get";
import { buttonStyle, buttonSize, colorStyle } from "../../../themes/customVariant";

const ButtonStyle = styled.button`
  display: inline-block;
  font-weight: ${themeGet("fontWeights.3", "400")};
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: none;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

  @media (hover: hover), not all {
    .btn:hover {
      color: ${themeGet("colors.body.color", "#3c4b64")};;
      text-decoration: none;
    }
  }

  &:focus,
  &.focus {
    outline: 0;
    box-shadow: 0 0 0 3px rgb(39 93 168 / 50%);
  }

  // Disabled comes first so active can properly restyle
  &:disabled,
  &.disabled {
    opacity: 0.65;
    box-shadow: none;
    cursor: default;
  }

  &:not(:disabled):not(.disabled) {
    cursor: pointer;

    &:active,
    .active {
      box-shadow: none;

      &:focus {
        box-shadow: 0 0 0 3px rgb(39 93 168 / 50%);
      }
    }
  }
  
  &.btn-block {
    display: block;
    width: 100%;
    
    // Vertically space out multiple block buttons
    + .btn-block {
      margin-top: ${themeGet("space.2", "8")}px;
    }
  }

  /* Style system support */ 
  ${buttonStyle}
  ${buttonSize}
  ${colorStyle}
  ${layout}
  ${space}
}
`;

const layoutProps = { ...propTypes.layout };
delete layoutProps.size;

ButtonStyle.propTypes = {
  ...layoutProps,
  ...propTypes.space,
};

export default ButtonStyle;
